import React, {FC} from 'react';

//MUI
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

//MUI ICONS
import PersonIcon from '@mui/icons-material/Person';

//CLAS
import DialogPanel from '../common/DialogPanel';
import LogoHorizontalColor from '../logos/LogoHorizontalColor';

//UTILS
import {useTranslation} from 'react-i18next';
import {SxProps} from '@mui/system/styleFunctionSx/styleFunctionSx';

const linkSx = {
  mt: 1,
  mb: 0,
  ml: 'auto',
  mr: 1
};

const dialogPanelSx: SxProps = {
  '&.DialogPanel-root': {
    height: '800px'
  }
};

export interface InfoMenuProps {
  isInfoMenuOpen: boolean,
  profile: {
    first_name: string,
    last_name: string,
    email: string
  } | undefined,
  onClose: () => void,
}

const InfoMenu: FC<InfoMenuProps> = ({
  isInfoMenuOpen,
  profile,
  onClose,
}) => {
  
  const {t} = useTranslation();
  
  const handleInfoMenuClose = () => onClose && onClose();

  return <DialogPanel
    isOpen={isInfoMenuOpen}
    onClose={handleInfoMenuClose}
    label={t('navigationMenu.title')}
    fullWidth
    sx={dialogPanelSx}
  >
    <Box sx={{display: 'flex', flexDirection: 'column', m: 0}}>
      <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', my: 2}}>
        <Box sx={{display: 'flex'}}>
          <PersonIcon fontSize="medium" color='primary' sx={{mr: 1, pb: 0.25}}/>
          <Typography color='primary' sx={{fontWeight: 900, textTransform: 'uppercase'}}>{profile?.first_name} {profile?.last_name}</Typography>
        </Box>
        <Typography sx={{color: 'grey.600', ml: 4}}>{profile?.email}</Typography>
      </Box>
    </Box>
    <Box sx={{display: 'flex', flexDirection: 'row', my: 1}}>
      <Chip label={
        <>
          <Typography variant='caption' sx={{fontWeight: 'bolder'}}>{t('navigationMenu.version')}: </Typography>

          <Typography variant='caption' sx={{mr: 1}}>
            {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              VERSION
            }
          </Typography>
          <Typography variant='caption' sx={{fontWeight: 'bolder'}}>{t('navigationMenu.hash')}: </Typography>
          <Typography variant='caption'>
            {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              HASH
            }
          </Typography>
        </>
      } size='small' sx={{mt: 1}}/>
      <Link sx={linkSx} href="https://geomatico.es" target="_blank">
        <LogoHorizontalColor width={80}/>
      </Link>
    </Box>
    
  </DialogPanel>;
};

export default InfoMenu;